import React, { useEffect, useRef, useState } from 'react';
import Styles from './input-search-styles.scss';
import { CloseCircleBlue, SearchIcon } from '../icons';
// import cssnames from 'classnames';
import classNames from 'classnames';
const InputSearch = ({ placeholder = 'Search...', onChange, loading = false, customStyle, notInitialFocus = false }) => {
    const [value, setValue] = useState('');
    const inputRef = useRef(null);
    const handleOnChange = (event) => {
        setValue(event.target.value);
        onChange(event);
    };
    useEffect(() => {
        if (!loading && !notInitialFocus) {
            inputRef.current.focus();
        }
    }, [loading]);
    return (React.createElement("div", { 
        // className={cssnames({
        //   [Styles.inputSearchWrap]: Styles.inputSearchWrap,
        //   [customStyle]: customStyle
        // })}
        className: classNames(Styles.inputSearchWrap, customStyle) },
        React.createElement(SearchIcon, null),
        React.createElement("input", { ref: inputRef, type: "text", placeholder: placeholder, onChange: e => {
                handleOnChange(e);
            }, value: value, disabled: loading }),
        value && value.length > 0 && (React.createElement(CloseCircleBlue, { onClick: e => {
                let newEvent;
                setValue('');
                onChange(Object.assign({ target: {
                        value: ''
                    } }, newEvent));
            } }))));
};
export default InputSearch;
